// extracted by mini-css-extract-plugin
module.exports = {"button":"fav-icon_button__ljgg9"};